import lazyWithRetry from "../../../utils/lazyWithRetry";
const CreateMenuItem = lazyWithRetry(() => import("./CreateMenuItem/CreateMenuItem"));
const EditMenuItem = lazyWithRetry(() => import("./EditMenuItem/EditMenuItem"));

export { CreateMenuItem, EditMenuItem }